import { render, staticRenderFns } from "./createContent.vue?vue&type=template&id=551e106c&scoped=true"
import script from "./createContent.vue?vue&type=script&lang=js"
export * from "./createContent.vue?vue&type=script&lang=js"
import style0 from "./createContent.vue?vue&type=style&index=0&id=551e106c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551e106c",
  null
  
)

export default component.exports